import ProtectedRoute from "./ProtectedRoute";

function getStatusColorClass(status) {
    switch (status) {
        case 'completed':
            return { title: 'Completed', color: 'green-500' };
        case 'onGoing':
            return { title: 'Ongoing', color: 'blue-500' };
        case 'pending':
            return { title: 'Pending', color: 'red-500' };
        default:
            return { title: status, color: 'purple-500' };
    }
}

export default getStatusColorClass;